/* src/app/pages/solicitudes/listasolicitudes/listasolicitudes.component.scss */
/*# sourceMappingURL=listasolicitudes.component.css.map */
